import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { AxiosError } from 'axios';
import {
  ErrorResponse,
  GetIssueQuery,
} from '@hud/portal-dtos/src/lib/webapp-common.dto';
import { PublicIssue } from '@hud/portal-dtos/issues-v2.dtos';
import { ISSUES_BASE } from '../consts';

export const ISSUE_ID = 'issue';

export default function useIssue(issueId: number, params: GetIssueQuery) {
  const { client, isReady } = useClient();
  return useQuery<PublicIssue, AxiosError<ErrorResponse>>({
    queryKey: [ISSUE_ID, issueId, params],
    queryFn: async () => {
      const response = await client.get<PublicIssue>(
        `${ISSUES_BASE}/v2/${issueId}`,
        {
          params,
        },
      );
      return PublicIssue.parse(response.data);
    },
    enabled: isReady && !!params.environmentName,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
